export const TIMEZONE = 'America/Tijuana';
export const TIME_OFFSET = 6;